// 보안 강화된 하이브리드 저장소: SessionStorage -> LocalStorage -> 메모리 순으로 시도
export const safeStorage = {
  setItem: (key, value) => {
    try {
      // 1차: sessionStorage 시도 (가장 안전)
      sessionStorage.setItem(key, value);
      return true;
    } catch (e) {
      try {
        // 2차: localStorage 시도
        localStorage.setItem(key, value);
        console.warn("SessionStorage가 차단됨. LocalStorage에 저장됩니다.");
        return true;
      } catch (localError) {
        // 3차: 메모리 저장 (페이지 새로고침 시 사라짐)
        window._tempStorage = window._tempStorage || {};
        window._tempStorage[key] = value;
        console.warn(
          "SessionStorage와 LocalStorage가 모두 차단됨. 메모리에 임시 저장됩니다."
        );
        return false;
      }
    }
  },

  getItem: (key) => {
    try {
      // 1차: sessionStorage에서 읽기
      const sessionValue = sessionStorage.getItem(key);
      if (sessionValue !== null) {
        return sessionValue;
      }
    } catch (e) {
      // sessionStorage 접근 실패
    }

    try {
      // 2차: localStorage에서 읽기
      const localValue = localStorage.getItem(key);
      if (localValue !== null) {
        return localValue;
      }
    } catch (e) {
      // localStorage 접근 실패
    }

    // 3차: 메모리에서 읽기
    return window._tempStorage?.[key] || null;
  },

  removeItem: (key) => {
    try {
      sessionStorage.removeItem(key);
    } catch (e) {}
    try {
      localStorage.removeItem(key);
    } catch (e) {}
    if (window._tempStorage) {
      delete window._tempStorage[key];
    }
  },

  // 모든 저장소에서 키 제거
  clearAll: () => {
    try {
      sessionStorage.clear();
    } catch (e) {}
    try {
      localStorage.clear();
    } catch (e) {}
    if (window._tempStorage) {
      window._tempStorage = {};
    }
  },

  // 토큰 암호화 저장 (추가 보안)
  setSecureItem: (key, value) => {
    try {
      // 간단한 Base64 인코딩 (실제 운영에서는 더 강력한 암호화 필요)
      const encodedValue = btoa(JSON.stringify(value));
      return this.setItem(key, encodedValue);
    } catch (e) {
      console.error("보안 저장 실패:", e);
      return false;
    }
  },

  getSecureItem: (key) => {
    try {
      const encodedValue = this.getItem(key);
      if (!encodedValue) return null;
      return JSON.parse(atob(encodedValue));
    } catch (e) {
      console.error("보안 복원 실패:", e);
      return null;
    }
  },
};
